import styled from "styled-components";

export const CheckboxRoundDiv = styled.div`
  .content-checkbox {
    display: flex;
    background-color: #EFEFF9;
    height: 50px;
    padding: 10px;
    box-sizing: border-box;
    align-items: center;
    cursor: pointer;
    border-radius: 20px;
    .icon-checkbox {  
      font-size: 20px;
      color: #2A28D6;
      margin-right: 5px;
      display: flex;
    }
    .text-checkbox {
      font-size: 17px;
      font-family: 'Nunito Sans';
      display: flex;
      margin: auto 0
    }
  }
`;
